import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/dev-site/dev-site/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TitleBlock = makeShortcode("TitleBlock");
const ResourceCard = makeShortcode("ResourceCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<TitleBlock slots="heading" theme="lightest" mdxType="TitleBlock" />
<h2 {...{
      "id": "latest-developer-news"
    }}>{`Latest Developer News`}</h2>
<ResourceCard slots="link, image, heading, text" width="33%" theme='lightest' className="useCaseCard" mdxType="ResourceCard" />
<p><a parentName="p" {...{
        "href": "https://www.youtube.com/playlist?list=PLGcTTvgqJhNXL5proK9dRmu5n5lCmLHc0"
      }}></a></p>
<p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "848px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "40%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/static/2a82d928995f14664a1ca7b4094948ff/5530d/ADL-2025.webp 320w", "/static/2a82d928995f14664a1ca7b4094948ff/0c8fb/ADL-2025.webp 640w", "/static/2a82d928995f14664a1ca7b4094948ff/45954/ADL-2025.webp 848w"],
            "sizes": "(max-width: 848px) 100vw, 848px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/static/2a82d928995f14664a1ca7b4094948ff/dd4a7/ADL-2025.png 320w", "/static/2a82d928995f14664a1ca7b4094948ff/0f09e/ADL-2025.png 640w", "/static/2a82d928995f14664a1ca7b4094948ff/4e098/ADL-2025.png 848w"],
            "sizes": "(max-width: 848px) 100vw, 848px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/static/2a82d928995f14664a1ca7b4094948ff/4e098/ADL-2025.png",
            "alt": "App Builder",
            "title": "App Builder",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
<h3 {...{
      "id": "adobe-developers-live"
    }}>{`Adobe Developers Live`}</h3>
<p>{`Watch the recordings from the AEM and Adobe Commerce Developers Live held in November 2025 as they explore AI, extensibility and Building the Agentic Web.`}</p>
<ResourceCard slots="link, image, heading, text" width="33%" theme='lightest' className="useCaseCard" mdxType="ResourceCard" />
<p><a parentName="p" {...{
        "href": "https://developer.adobe.com/express/add-ons/"
      }}></a></p>
<p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "56.25%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/static/626d53429622009c145b3491706f12d5/5530d/Express_AddOns.webp 320w", "/static/626d53429622009c145b3491706f12d5/0c8fb/Express_AddOns.webp 640w", "/static/626d53429622009c145b3491706f12d5/94b1e/Express_AddOns.webp 1280w", "/static/626d53429622009c145b3491706f12d5/0b34d/Express_AddOns.webp 1920w", "/static/626d53429622009c145b3491706f12d5/d5269/Express_AddOns.webp 2560w", "/static/626d53429622009c145b3491706f12d5/b6a6b/Express_AddOns.webp 2707w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/static/626d53429622009c145b3491706f12d5/8980b/Express_AddOns.jpg 320w", "/static/626d53429622009c145b3491706f12d5/56d4e/Express_AddOns.jpg 640w", "/static/626d53429622009c145b3491706f12d5/62aaf/Express_AddOns.jpg 1280w", "/static/626d53429622009c145b3491706f12d5/aaf92/Express_AddOns.jpg 1920w", "/static/626d53429622009c145b3491706f12d5/36eba/Express_AddOns.jpg 2560w", "/static/626d53429622009c145b3491706f12d5/42f76/Express_AddOns.jpg 2707w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/static/626d53429622009c145b3491706f12d5/62aaf/Express_AddOns.jpg",
            "alt": "Express Add-Ons",
            "title": "Express Add-Ons",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
<h3 {...{
      "id": "make-building-add-ons-your-superpower"
    }}>{`Make building add-ons your superpower`}</h3>
<p>{`Build add-ons to extend the functionality of Adobe Express and unlock new creative workflows for users.`}</p>
<ResourceCard slots="link, image, heading, text" width="33%" theme='lightest' className="useCaseCard" mdxType="ResourceCard" />
<p><a parentName="p" {...{
        "href": "https://youtube.com/playlist?list=PLcVEYUqU7VRc7EgPijKHLu21jnIDENB2V&si=5C7PpSS-NUKQe62Y"
      }}></a></p>
<p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "800px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "40%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/static/654ae1b27313dda5eefad8f5030d5b09/5530d/DevLive_Jun2025.webp 320w", "/static/654ae1b27313dda5eefad8f5030d5b09/0c8fb/DevLive_Jun2025.webp 640w", "/static/654ae1b27313dda5eefad8f5030d5b09/cf465/DevLive_Jun2025.webp 800w"],
            "sizes": "(max-width: 800px) 100vw, 800px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/static/654ae1b27313dda5eefad8f5030d5b09/dd4a7/DevLive_Jun2025.png 320w", "/static/654ae1b27313dda5eefad8f5030d5b09/0f09e/DevLive_Jun2025.png 640w", "/static/654ae1b27313dda5eefad8f5030d5b09/78d47/DevLive_Jun2025.png 800w"],
            "sizes": "(max-width: 800px) 100vw, 800px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/static/654ae1b27313dda5eefad8f5030d5b09/78d47/DevLive_Jun2025.png",
            "alt": "Adobe MAX",
            "title": "Adobe MAX",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
<h3 {...{
      "id": "adobe-developers-live-replay"
    }}>{`Adobe Developers Live Replay`}</h3>
<p>{`Watch the recordings from the Adobe Express and Creative Cloud Adobe Developers Live, our virtual conference we hosted June 24-25, 2025.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      